import React, { useEffect, lazy } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/StructuredData';
import { ServiceNav } from '../components/ServiceNav';
export function SpringDeepCleaning() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full font-sans bg-white flex flex-col" data-id="element-1597">
      <SEOHead title="Spring / Deep Cleaning | Smith & Jengs Cleaning Services" description="Thorough spring and deep cleaning services in Bicester and Oxfordshire. Refresh your home with our meticulous attention to detail." canonical="https://smithandjengs.com/spring-deep-cleaning" data-id="element-1598" />
      <BreadcrumbSchema items={[{
      name: 'Home',
      url: 'https://smithandjengs.com/'
    }, {
      name: 'Spring / Deep Cleaning',
      url: 'https://smithandjengs.com/spring-deep-cleaning'
    }]} data-id="element-1599" />
      <Navbar data-id="element-1600" />

      <main className="flex-1" data-id="element-1601">
        {/* 1. Hero Banner */}
        <section className="relative w-full h-[55vh] min-h-[420px] max-h-[600px] overflow-hidden bg-[#1a2744]" data-id="element-1602">
          <div className="absolute inset-0" data-id="element-1603">
            <img src="https://cdn.magicpatterns.com/uploads/pwzkMp41NqfVwFtPzbYese/sj-website-deep-clean-banner.png" alt="Window cleaning with squeegee" className="w-full h-full object-cover object-center" decoding="async" data-id="element-1604" />
            {/* Dark gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#1a2744]/90 via-[#1a2744]/50 to-transparent" data-id="element-1605" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a2744]/70 via-transparent to-transparent" data-id="element-1606" />
          </div>

          <div className="relative z-10 h-full flex items-end px-6 md:px-12 pb-12 pt-32" data-id="element-1607">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} className="max-w-7xl mx-auto w-full" data-id="element-1608">
              <h1 className="font-bebas text-white leading-[0.85] tracking-wide" data-id="element-1609">
                <span className="text-7xl md:text-[9rem] lg:text-[11rem] block" data-id="element-1610">
                  SPRING / DEEP
                </span>
                <span className="font-serif-playfair italic font-normal normal-case text-[#e91e8c] text-6xl md:text-[8rem] lg:text-[10rem] block -mt-2 md:-mt-6" data-id="element-1611">
                  Cleaning
                </span>
              </h1>
            </motion.div>
          </div>
        </section>

        <ServiceNav data-id="element-1612" />

        {/* 2. Description + Image Section */}
        <section className="w-full bg-white py-16 md:py-24 px-6 md:px-12" data-id="element-1613">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-1614">
            {/* Left: Text */}
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex flex-col lg:max-w-md" data-id="element-1615">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1a2744] mb-6 leading-tight" data-id="element-1616">
                A thorough refresh
                <br data-id="element-1617" />
                for your entire
                <br data-id="element-1618" />
                home.
              </h2>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-1619">
                Sometimes your home needs more than just a standard clean. Our
                deep cleaning service tackles the hard-to-reach areas and
                built-up grime, restoring your home to its sparkling best.
                Perfect for seasonal cleaning or preparing for special
                occasions.
              </p>
            </motion.div>

            {/* Right: Image */}
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="w-full h-[400px] lg:h-[500px] rounded-sm overflow-hidden" data-id="element-1620">
              <img src="https://cdn.magicpatterns.com/uploads/emDHfxCvuYnUEkXibGbjn6/kitchen-clean-dog.png" alt="Clean kitchen with dog" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-1621" />
            </motion.div>
          </div>
        </section>

        {/* 3. Services List Section */}
        <section className="w-full bg-white pb-16 md:pb-24 px-6 md:px-12" data-id="element-1622">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-1623">
            {/* Left: Image */}
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="w-full h-[400px] lg:h-[500px] rounded-sm overflow-hidden order-2 lg:order-1" data-id="element-1624">
              <img src="https://cdn.magicpatterns.com/uploads/rJgFvMvZju8gYeLxkrt7X2/lady-cleaning-window.png" alt="Lady cleaning a window" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-1625" />
            </motion.div>

            {/* Right: List */}
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex flex-col order-1 lg:order-2" data-id="element-1626">
              <ul className="flex flex-col w-full" data-id="element-1627">
                {['Inside cabinets and drawers', 'Baseboards and door frames', 'Behind and under appliances', 'Detailed dusting of all surfaces'].map((item, i) => <li key={i} className="border-b border-gray-300 py-6 text-[#1a2744] text-lg md:text-xl font-medium first:pt-0" data-id="element-1628">
                    {item}
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </section>

        {/* 4. CTA Section */}
        <section className="w-full bg-[#f8f9fa] py-16 px-6 md:px-12" data-id="element-1629">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 text-center md:text-left" data-id="element-1630">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2744] leading-tight" data-id="element-1631">
              Click <span className="text-[#e91e8c]" data-id="element-1632">Book Online</span> to set
              up
              <br className="hidden md:block" data-id="element-1633" /> a Spring / Deep Cleaning
            </h2>
            <Link to="/spring-deep-cleaning-quote" className="bg-[#e91e8c] hover:bg-[#d0187c] text-white px-8 py-4 rounded-full font-semibold tracking-wide transition-colors shadow-md flex items-center gap-3 whitespace-nowrap" data-id="element-1634">
              Book Online <span className="text-xl leading-none" data-id="element-1635">&rarr;</span>
            </Link>
          </motion.div>
        </section>
      </main>

      <Footer data-id="element-1636" />
    </div>;
}